import { render, staticRenderFns } from "./CreateStandardizationDialog.vue?vue&type=template&id=6c25f785&scoped=true&"
import script from "./CreateStandardizationDialog.vue?vue&type=script&lang=js&"
export * from "./CreateStandardizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateStandardizationDialog.vue?vue&type=style&index=0&id=6c25f785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25f785",
  null
  
)

export default component.exports